import { message } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { trackQueryError } from '@src/utils/sensor/apptracker';
import { setDefaultApp } from '@src/api/applications';

const useSetDefaultApp = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (payload: any) => {
      return setDefaultApp(payload);
    },
    {
      onSuccess: (response) => {
        if (response.data === 'OK') {
          queryClient.invalidateQueries(['profile', 'applications']);
          message.success(`Default application updated successfully!`);
        }
      },
      onError: (err) => {
        trackQueryError({ type: 'update-default-account', err });
      },
    },
  );

  return mutation;
};

export default useSetDefaultApp;
